/*
 * @Description:
 * @Author: rqcheng
 * @Date: 2022-06-09 12:45:36
 * @LastEditors: rqcheng
 * @LastEditTime: 2025-06-20 15:53:59
 */
import { setAccessToken } from "../plugins/auth";
import * as types from "./mutationsType";
export default {
  [types.ACCESS_TOKEN](state, token) {
    state.accessToken = token;
    setAccessToken(token);
  },
  [types.USER_PROFILE](state, profile) {
    state.profile = profile;
  },
  [types.OPTIONS_EDIT](state, options) {
    state.options = options;
  },
  [types.ARTICLE_TITLE_EDIT](state, article_title) {
    state.article_title = article_title;
  },
  [types.CURRENT_REGION](state, current_region) {
    //profile
    state.current_region = current_region;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js